import { useEffect } from 'react';
import { createFilterActions } from '../../actions/filter.actions';
import { BwicFilterType } from '../../types/filters/FilterState';
import { useAppDispatch } from '../../effects/useAppDispatch';
import { useAppSelector } from '../../effects/useAppSelector';
import { BwicFilters } from '../filters/BwicFilters';
import { isRequesting, isRequestNone } from '../../utils/request-state.utils';

interface Props {
    handleApplyFilter: () => void;
}

const filterActions = createFilterActions(BwicFilterType.Eval);

export const EvalFilter = ({ handleApplyFilter }: Props) => {
    const dispatch = useAppDispatch();

    const isFilterChanged = useAppSelector(s => s.filters.eval.filterChanged);
    const isFilterModified = useAppSelector(s => s.filters.eval.filterModified);
    const visibleFilters = useAppSelector(s => s.filters.eval.visibleFilters);
    const filter = useAppSelector(s => s.filters.eval.filter);
    const lastAppliedFilter = useAppSelector(s => s.filters.eval.lastAppliedFilter);
    const requestState = useAppSelector(s => s.entities.eval.requestState);

    useEffect(() => {
        return () => {
            dispatch(filterActions.resetFilter());
            dispatch(filterActions.resetFilterState());
            dispatch(filterActions.resetFiltersVisibility());
        }
    }, [dispatch])

    const handleVisibilityChange = (filterName: string) => {
        dispatch(filterActions.filterVisibilityChange(filterName))
    }

    const handleClear = () => {
        dispatch(filterActions.resetFiltersAndUnselectSavedFilter());
        handleApplyFilter();
    };

    return (
        <BwicFilters
            withAlerts={true}
            isSearching={isRequestNone(requestState) || isRequesting(requestState)}
            onApply={handleApplyFilter}
            onReset={handleClear}
            visibleFilters={visibleFilters}
            hiddenFilters={[]}
            filterType={BwicFilterType.Eval}
            lastAppliedFilter={lastAppliedFilter}
            filter={filter}
            filterChanged={isFilterChanged}
            filterModified={isFilterModified}
            onVisibilityChange={handleVisibilityChange}
            saveFilterVisible={false}
        />
    )
}
